import React from 'react';
import { connect } from 'react-redux';
import { Button, PersistentMenu } from 'eymp-uicomps';
import { PersistentMenuItem } from 'eymp-uicomps/components/PersistentMenu';
import HomeIcon from '../../../assets/dashboardIcons/HomeIcon.png';
import ProfileIcon from '../../../assets/dashboardIcons/ProfileIcon.png';
import MessageIcon from '../../../assets/dashboardIcons/MessageIcon.png';
import DocumentIcon from '../../../assets/dashboardIcons/DocumentIcon.png';
import EmployeeIcon from '../../../assets/dashboardIcons/people_icon.png';
import ReportsIcon from '../../../assets/dashboardIcons/ReportsIcon.png';
import SIIcon from '../../../assets/dashboardIcons/si.png';
import LogoutIcon from '../../../assets/dashboardIcons/LogoutIcon.png';

import intl from 'react-intl-universal';
import {
  NEW_DASHBOARD_URL,
  PROFILE_URL,
  MESSAGING_URL,
  DOCUMENTS_URL,
  EMPLOYEES_URL,
  SERVICEINIT_URL,
  LOGOUT_URL,
} from '../../../constants/constants';
import { reportUrls } from '../../../constants/reportUrls';
import { generatePath } from 'react-router';
import { CustomAlertDialog } from 'src/ui/library/Dialog';
import { getUserInfoSelector } from 'src/ui/features/Login/state/loginReselect';
import { fnOnNavOpen, isActiveMenu } from 'src/helpers/commonFunctions';
import _ from 'lodash';
import ToolTip from 'src/ui/library/ToolTip';

class CollapsibleMenu extends React.Component {
  state = {
    logoutRoute: null,
    isExternalURL: false,
    openDialog: false,
    isNavOpen: false,
  };

  componentDidMount() {
    let logoutProps = { route: LOGOUT_URL, isExternal: false };
    this.setState({
      logoutRoute: logoutProps,
    });
    document.addEventListener('click', fnOnNavOpen);
  }

  componentWillUnmount() {}

  handleOnLogout() {
    this.setState({ openDialog: true });
  }

  toggleModal() {
    this.setState({ openDialog: !this.state.openDialog });
  }

  _onCancel(isClose) {
    this.toggleModal();
    if (typeof isClose === 'boolean') {
      return;
    }
    if (!this.state.logoutRoute.route.includes('/?logout&redirect')) {
      window.location.href = this.state.logoutRoute.route + '&mode=1';
    }
  }

  _onConfirm() {
    this.toggleModal();
    let url = '';
    if (this.state.logoutRoute.route.includes('/?logout&redirect')) {
      url = this.state.logoutRoute.route + '&mode=4';
    } else {
      url = this.state.logoutRoute.route + '&mode=2';
    }

    window.location.href = url;
  }
  getLocationPath() {
    return window && window.location && window.location.pathname ? window.location.pathname.toLowerCase() : '';
  }
  isSameRouteClicked(static_route) {
    return this.getLocationPath().indexOf(static_route.toLowerCase()) !== -1;
  }
  handleOnNavClick(isOpen) {
    this.setState({ isNavOpen: isOpen });
  }

  getEngagment(length) {
    let engagementName = this.props.userInfo.engagementName ? _.toUpper(this.props.userInfo.engagementName) : '';
    if (!length) return engagementName;
    return engagementName ? (engagementName.length > length ? _.join(_.take(engagementName, length), '') + '...' : engagementName) : '';
  }

  isEngagementNameEnabled() {
    return (
      <div className="client-name">
        <div title={this.getEngagment()} className={'title-text font-12 position-absolute clap-text'}>
          {this.getEngagment(37)}
        </div>
      </div>
    );
  }

  render() {
    const { isApplicant, isCorpClient, isEYPro, messageCount, isCorporateClientLineManager } = this.props;

    return (
      <div className="panel">
        <PersistentMenu
          isPersistentMenuOpen={this.state.isNavOpen}
          setIsPersistentMenuOpen={isOpen => this.handleOnNavClick(isOpen)}
          isR5Enabled={true}>
          {this.isEngagementNameEnabled()}

          <ToolTip
            title={intl.get('globalMenu.dashboard')}
            placement="right"
            className={this.state.isNavOpen ? 'd-none' : 'hide-tooltip-space'}
            hideButton={true}>
            <PersistentMenuItem
              className={isActiveMenu(NEW_DASHBOARD_URL)}
              key="Dashboard"
              route={generatePath(NEW_DASHBOARD_URL)}
              label={intl.get('globalMenu.dashboard')}
              icon={<img src={HomeIcon} alt="Home" />}
              isExternal={true}
            />
          </ToolTip>
          <ToolTip
            title={intl.get('globalMenu.myProfile')}
            placement="right"
            className={this.state.isNavOpen ? 'd-none' : 'hide-tooltip-space'}
            hideButton={true}>
            <PersistentMenuItem
              key="Profile"
              className={isActiveMenu(PROFILE_URL)}
              isExternal={true}
              route={generatePath(PROFILE_URL)}
              label={intl.get('globalMenu.myProfile')}
              icon={<img src={ProfileIcon} alt="Profile" />}
            />
          </ToolTip>

          <ToolTip
            title={`${intl.get('globalMenu.messages')} (${messageCount})`}
            placement="right"
            className={this.state.isNavOpen ? 'd-none' : 'hide-tooltip-space'}
            hideButton={true}>
            <PersistentMenuItem
              className={'position-relative ' + isActiveMenu(MESSAGING_URL)}
              isExternal={true}
              route={generatePath(MESSAGING_URL)}
              label={`${intl.get('globalMenu.messages')} (${messageCount})`}
              icon={
                <div>
                  <img src={MessageIcon} alt="Messages" /> <div className="badge">{messageCount}</div>
                </div>
              }
            />
          </ToolTip>
          {(isEYPro || isCorpClient || isApplicant || isCorporateClientLineManager) && (
            <ToolTip
              title={intl.get('globalMenu.documents')}
              placement="right"
              className={this.state.isNavOpen ? 'd-none' : 'hide-tooltip-space'}
              hideButton={true}>
              <PersistentMenuItem
                className={isActiveMenu(DOCUMENTS_URL)}
                route={generatePath(DOCUMENTS_URL)}
                isExternal={true}
                label={intl.get('globalMenu.documents')}
                icon={<img src={DocumentIcon} alt="Documents" />}
              />
            </ToolTip>
          )}
          {(isEYPro || isCorpClient) && this.props.userInfo && this.props.userInfo.serviceInitiationRights && (
            <ToolTip
              title={intl.get('globalMenu.serviceInitiation')}
              placement="right"
              className={this.state.isNavOpen ? 'd-none' : 'hide-tooltip-space'}
              hideButton={true}>
              <PersistentMenuItem
                isExternal={true}
                className={isActiveMenu(SERVICEINIT_URL)}
                route={generatePath(SERVICEINIT_URL)}
                label={intl.get('globalMenu.serviceInitiation')}
                icon={<img src={SIIcon} alt="ServiceInitiation " />}
              />
            </ToolTip>
          )}
          {isCorpClient && (
            <ToolTip
              title={intl.get('globalMenu.employees')}
              placement="right"
              className={this.state.isNavOpen ? 'd-none' : 'hide-tooltip-space'}
              hideButton={true}>
              <PersistentMenuItem
                isExternal={true}
                className={isActiveMenu(EMPLOYEES_URL)}
                route={EMPLOYEES_URL}
                label={intl.get('globalMenu.employees')}
                icon={<img src={EmployeeIcon} alt="Employees" />}
              />
            </ToolTip>
          )}
          {(isEYPro || isCorpClient || isCorporateClientLineManager) && (
            <ToolTip
              title={intl.get('globalMenu.reports')}
              placement="right"
              className={this.state.isNavOpen ? 'd-none' : 'hide-tooltip-space'}
              hideButton={true}>
              <PersistentMenuItem
                className={isActiveMenu(reportUrls)}
                route={reportUrls}
                isExternal={true}
                label={intl.get('globalMenu.reports')}
                openNewTab
                icon={<img src={ReportsIcon} alt="reports" />}
              />
            </ToolTip>
          )}
          {/* <PersistentMenuItem route="/logout" label="Logout" icon={<img src={LogoutIcon} alt="Sign out" />} className="footer-btn" /> */}
          <div className="tooltip-top-auto">
            <ToolTip
              title={intl.get('globalMenu.logout')}
              placement="right"
              className={this.state.isNavOpen ? 'd-none' : 'tooltip-top-auto hide-tooltip-space logout-btn-tooltip'}
              hideButton={true}>
              <Button className="footer-btn" onClick={e => this.handleOnLogout()}>
                {' '}
                <img src={LogoutIcon} alt="Sign out" /> <span>{intl.get('globalMenu.logout')}</span>
              </Button>
            </ToolTip>
          </div>
        </PersistentMenu>

        {this.state.openDialog && (
          <CustomAlertDialog
            open
            showConfirm={true}
            noMaxWidth={true}
            closeIcon={true}
            title={intl.get('globalMenu.logoutConfirmation')}
            cancelText={intl.get('globalMenu.imlLogout')}
            confirmText={intl.get('globalMenu.eympLogout')}
            onCancel={e => this._onCancel(e)}
            onConfirm={() => this._onConfirm()}
            toggleDrawer={() => this.toggleModal()}>
            <span>{intl.get('global.logout.text')}</span>
          </CustomAlertDialog>
        )}
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    composeClick: state.newDashboard.composeClick,
    userInfo: getUserInfoSelector(state),
  };
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(CollapsibleMenu);
